import React ,{useEffect, useState} from 'react'
import Cookies from 'universal-cookie';
import { captureException } from '@sentry/browser';
import { DataGrid,GridToolbarQuickFilter } from '@mui/x-data-grid';
import './Services.css'
import GitHubIcon from '@mui/icons-material/GitHub';
import UpdateIcon from '@mui/icons-material/Update';
import Tooltip from '@mui/material/Tooltip';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import Modal from '../Modal/Modal';
import datadog_icon from '../../images/DDOG.svg'
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Papa from 'papaparse';
import KeyIcon from '@mui/icons-material/Key';

const cookies = new Cookies();

export default function Services() { 

    const [services,set_services]=useState()
    const[services_status,set_services_status] = useState()
    const [columns,set_columns] = useState([])
    const [open_lock_dialog, set_open_lock_dialog] = useState(false);
    const[open_unlock_dialog,set_open_unlock_dialog] = useState(false)
    const [reason , set_reason] = useState("")
    const [filterModel, setFilterModel] = React.useState({
      items: [
        {
          columnField: 'action',
          operatorValue: 'contains',
          value: ""
        },
      ],
    });

    useEffect( () => {
        var options = {
          'method': 'POST',
          'headers': {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "code": cookies.get("code"),
        })
    };
    fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/github/services_details/" , options).then(response=>response.json())
    .then(async data=>{ 
      try{
        let backendIndex = data.findIndex(json => json.service_name === "backend");
          if (backendIndex !== -1) {
            let backendJson = data.splice(backendIndex, 1)[0];
            data.unshift(backendJson);
          }
        set_services(data)
        for (const service of data){
          if(service.cronjobs == "[]"){
            set_services(services => services.map(item => item.service_name === service.service_name ? {...item, hasCronJobs: "false"} : item))
          }
          else{
            set_services(services => services.map(item => item.service_name === service.service_name ? {...item, hasCronJobs: "true"} : item))
          }
          set_services(services => services.map(item => item.service_name === service.service_name ? {...item, pubsub: service.pubsub.toString()} : item))
        }
      }
      catch (error){
        const event_id = captureException(error);
      }

     });
     
    },[])

  const handleClickOpen = () => {
    set_open_lock_dialog(true);
  };
  const handleClickOpen_unlock = () => {
    set_open_unlock_dialog(true);
  };

  const handle_lock_dialog_close = () => {
    set_open_lock_dialog(false);
  };

  const handle_unlock_dialog_close = () => {
    set_open_unlock_dialog(false);
    set_reason("")
  };

  useEffect( () => {
    var options = {
      'method': 'POST',
      'headers': {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "code": cookies.get("code")
        })
    };
    fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/releaseProgress/get_services_lock_status/" , options).then(response=>response.json())
    .then(async data=>{ 
      try{
        set_services_status(data)
      }
      catch (error){
        const event_id = captureException(error);
        console.log('error logged', { event_id });
      }

    });

    
    },[])

    function block_deployment(){
      var options = {
        'method': 'POST',
        'headers': {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        "code": cookies.get("code"),
        "reason" : reason,
        "status" : !services_status.status
      })
      };
      fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/releaseProgress/set_services_lock_status/" , options).then(response=>response.json())
      .then(async data=>{ 
        try{
        }
        catch(error) {
          console.log(error)
        }
      });
      set_open_lock_dialog(false)
      set_open_unlock_dialog(false)
      set_reason("")
      set_services_status({"status": !services_status.status , "reason" : reason , "user" : cookies.get("name")})
    }
    useEffect( () => {
      set_columns ( [
        {
          field: "secret_link",
          headerName: "",
          filterable: false,
          sortable: false,
          width: 100,
          renderCell: (params) => {
            return (
              <div
                className="d-flex justify-content-between align-items-center"
                style={{ zIndex:10000 , position: "relative"}}
              >
                <Tooltip title={params.row.has_secrets ? "This service has secrets" : "This service has no secrets"} followCursor>
                  <KeyIcon sx={{ color: params.row.has_secrets ? ("blue"): ("red")}} index={params.row.id} />
                </Tooltip>
              </div>
            );
          }
        },
        { field: 'service_name', headerName: 'Service Name', width: 300,
        renderCell: (params) => {
                  return (<strong>{params.row.service_name}</strong>)}},
        { field: 'code_owner', headerName: 'Code Owner', width: 200 } ,
        {field:"node_version" , headerName: "Node Version" , width:200},
        {
          field: "github_link",
          headerName: "GitHub",
          filterable: false,
          sortable: false,
          width: 200,
          renderCell: (params) => {
            return (
              <div
                className="d-flex justify-content-between align-items-center"
                style={{ cursor: "pointer", zIndex:10000 , position: "relative"}}
              >
                <GitHubIcon index={params.row.id} />
              </div>
            );
          }
        },
        {
          field: "datadog_link",
          headerName: "Datadog",
          filterable: false,
          sortable: false,
          width: 200,
          renderCell: (params) => {
            return (
              <div
                className="d-flex justify-content-between align-items-center"
                style={{ cursor: "pointer", zIndex:10000 , position: "relative"}}
              >
                <img src={datadog_icon} className="icon" index={params.row.id} style={{"border": "none"}}/>
              </div>
            );
          }
        },
      ]);
      if(cookies.get("login") == "nehoramoshe" || cookies.get("login") == "markrity" || cookies.get("login") == "matanshikli"){
        set_columns(columns => [...columns, { field: 'pubsub', headerName: 'pubsub', width: 200 },
        { field: 'hasCronJobs', headerName: 'cronjobs', width: 200 }]);
      }
    },[])

    const update_services = () => {
      var options = {
        'method': 'POST',
        'headers': {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        "code": cookies.get("code")
      })
      };
      fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/github/update_services_details/" , options).then(response=>response.json())
      .then(async data=>{ 
        try{
          let backendIndex = data.findIndex(json => json.service_name === "backend");
          if (backendIndex !== -1) {
            let backendJson = data.splice(backendIndex, 1)[0];
            data.unshift(backendJson);
          }
          set_services(data)
        }
        catch (error){
          const event_id = captureException(error);
          console.log('error logged', { event_id });
        }

      });
    };
      
    function QuickSearchToolbar() {
      return (
          <GridToolbarQuickFilter />
      );
    }

    function update_code_owner_filter(cellData){
      if(filterModel.items[0]?.value==cellData.row.code_owner){
        setFilterModel({
          items: [
            {
              columnField: 'code_owner',
              operatorValue: 'contains',
              value: ""
            },
          ],
        })
      }
      else{
        setFilterModel({
          items: [
            {
              columnField: 'code_owner',
              operatorValue: 'contains',
              value: cellData.row.code_owner
            },
          ],
        })
      }
      
    }

    function update_pubsub_filter(cellData){
      if(filterModel.items[0]?.value==cellData.row.pubsub){
        setFilterModel({
          items: [
            {
              columnField: 'pubsub',
              operatorValue: 'contains',
              value: ""
            },
          ],
        })
      }
      else{
        setFilterModel({
          items: [
            {
              columnField: 'pubsub',
              operatorValue: 'contains',
              value: cellData.row.pubsub
            },
          ],
        })
      }
    }
    function update_cronjobs_filter(cellData){
      if(filterModel.items[0]?.value==cellData.row.hasCronJobs){
        setFilterModel({
          items: [
            {
              columnField: 'hasCronJobs',
              operatorValue: 'contains',
              value: ""
            },
          ],
        })
      }
      else{
        setFilterModel({
          items: [
            {
              columnField: 'hasCronJobs',
              operatorValue: 'contains',
              value: cellData.row.hasCronJobs
            },
          ],
        })
      }
    }
      
    function update_node_version_filter(cellData){
      if(filterModel.items[0]?.value==cellData.row.node_version){
        setFilterModel({
          items: [
            {
              columnField: 'node_version',
              operatorValue: 'contains',
              value: ""
            },
          ],
        })
      }
      else{
        setFilterModel({
          items: [
            {
              columnField: 'node_version',
              operatorValue: 'contains',
              value: cellData.row.node_version
            },
          ],
        })
      }
      
    }
    const export_csv = () => {
      const csv = Papa.unparse(services);
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.href = url;
      link.setAttribute('download', "Services.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    return (
        <div className="split right" >
          <div className='update'>
          <Tooltip title="Update services" followCursor>
            <UpdateIcon onClick={() =>update_services()} style={{ cursor: "pointer"}}/>
            </Tooltip>
            <Tooltip title="export to CSV" followCursor >
              <FileDownloadIcon onClick={() =>export_csv()} style={{ cursor: "pointer"}}/>
            </Tooltip>
          </div>
          <div className='services_title'>
          {services_status && services_status.status ? 
          (
            <a >
            <Tooltip title="All services deployment blocked. Click to unblock it." followCursor className="lock_services">
              <LockIcon onClick={() =>handleClickOpen_unlock()}/> 
            </Tooltip>
            </a>
           
          ):(
            <a >
            <Tooltip title="Click to lock all services deployment" followCursor className="lock_services">
              <LockOpenIcon onClick={() =>handleClickOpen()}/>
            </Tooltip>
           </a>
          )}
          <a className="workiz_services_title">
            Workiz services
          </a>
          {services_status && services_status.status &&  <div className='setvices_lock_details'>locked by {services_status.user}. lock reason - {services_status.reason} </div>}
          </div>
          <div style={{ height: '85%', width: '100%' , "background-color": "white" }} className="services_table">
            {services && <DataGrid
              filterModel={filterModel}
              onFilterModelChange={(newFilterModel) => setFilterModel(newFilterModel)}
              rows={services}
              columns={columns}
              pageSize={50}
              sx={{
                boxShadow: 2,
                '& .MuiDataGrid-cell:hover': {
                  color: 'primary.main',
                },
              }}
              rowsPerPageOptions={[50]}
              components={{ Toolbar: QuickSearchToolbar }}
              disableSelectionOnClick={true}
              onCellClick={(cellData) => {
                if(cellData.field=="github_link"){
                  window.open(cellData.row.github_link, '_blank', 'noreferrer')
                }
                if(cellData.field=="datadog_link"){
                  window.open(`https://us5.datadoghq.com/apm/services/${cellData.row.service_name}`, '_blank', 'noreferrer')
                }
                else if(cellData.field=="service_name"){
                  window.location.assign(`/service?service=${cellData.row.service_name}`)
                }
                else if(cellData.field=="code_owner"){
                  update_code_owner_filter(cellData)
                }
                else if(cellData.field=="node_version"){
                  update_node_version_filter(cellData)
                }
                else if(cellData.field=="pubsub"){
                  update_pubsub_filter(cellData)
                }
                else if(cellData.field=="hasCronJobs"){
                  update_cronjobs_filter(cellData)
                }
              }}
            />
            }

      <Modal open={open_lock_dialog} onClose={()=>handle_lock_dialog_close} 
          title={"Lock deployment to all services"}
          text={"To lock deployments to all the services, please write the reason"}
          textField={true}
          textFieldLabel={"Write the reason"}
          textFieldSetText={set_reason}
          buttons={[
                    {"text":"Cancel" , "style":{"color": "#3E45EF" , "font-weight": "600" , "border": "hidden"} , "onClick" : ()=>handle_lock_dialog_close() },
                    {"text":"Lock" , "style":{ "font-weight": "600","border": "hidden" , "width": "76px" } , "onClick" : ()=>block_deployment() ,"disabled": !reason.length ,  "class": "main"}
                  ]}
        />

      <Modal open={open_unlock_dialog} onClose={()=>handle_unlock_dialog_close} 
          title={"Unlock deployment to all services"}
          text={"To unlock deployments to all the services, please write the reason"}
          textField={true}
          textFieldLabel={"Write the reason"}
          textFieldSetText={set_reason}
          buttons={[
                    {"text":"Cancel" , "style":{"color": "#3E45EF" , "font-weight": "600" , "border": "hidden"} , "onClick" : ()=>handle_unlock_dialog_close() },
                    {"text":"Lock" , "style":{ "font-weight": "600","border": "hidden" , "width": "76px" } , "onClick" : ()=>block_deployment() ,"disabled": !reason.length ,  "class": "main"}
                  ]}
        />

          </div>
        </div>
    )


}